<template>
  <div>
    <Banner :classType="1" />
    <Menu v-if="lang == 'zh'" />

    <div v-show="showENC">
      <div
        class="pageTitle wow animate__slideInUp"
        ref="note"
        :class="{ titleEn: lang == 'en' }"
      >
        <h2>联系我们</h2>
        <p>CONTACT US</p>
      </div>

      <div class="wrap JobAddress wow animate__slideInUp">
        <el-row :gutter="30">
          <el-col
            :xs="24"
            :sm="24"
            :md="8"
            :key="idx"
            v-for="(item, idx) in contactList"
          >
            <div class="itemJob">
              <i class="el-icon-location-outline"></i>
              <h3>{{ item.Name }}</h3>

              <div
                class="item"
                :key="subIdx"
                v-for="(subItem, subIdx) in item.ContactInfos"
                v-html="changeValue(subItem)"
              ></div>
            </div>
          </el-col>
        </el-row>

        <div class="pageBox" v-if="showPage" >
          <Pagination @pageChange="getContactList" :PagingInfo="PagingInfo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "@/views/components/Banner";
import Menu from "./Menu.vue";
import { WOW } from "wowjs";
import HonorSwiper from "./HonorSwiper.vue";
import Pagination from "@/views/components/Pagenation";
import { changeText } from "@/utils/tool";

export default {
  data() {
    return {
      type: this.$route.query.type || "",
      lang: this.$global.lang,
      newsNav: [
        { honorNum: 3, honorIntro: "国家级荣誉" },
        { honorNum: 13, honorIntro: "协会荣誉" },
        { honorNum: 5, honorIntro: "省级荣誉" },
        { honorNum: 4, honorIntro: "市级荣誉" },
      ],
      newsOn: 0,
      list: [],
      AwardsInfos: [],
      moment: this.$moment,
      contactList: [],
      imgUrl: "",
      showPage:false,
      showHonor: false,
      showSwiper: false,
      showENO: true,
      showENC: true,
      pageCur:1,
      PagingInfo: {},
    };
  },
  components: {
    Banner,
    Menu,
    HonorSwiper,
    Pagination,
  },
  methods: {
    initSwip() {
      var swiper = new Swiper(".mySwiper", {
        slidesPerView: 3,
        slidesPerGroup: 3,
        // loop: true,
        // loopFillGroupWithBlank: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".scollBtn",
          prevEl: ".scollBtnLeft",
        },
        createElements: true,
        init: false,
      });
      swiper.init();
      swiper.setTranslate(0);
    },

    newsTabFn(idx) {
      // this.showSwiper = false;
      this.newsOn = idx;
      this.AwardsInfos = this.list[idx].AwardsInfos;
      // this.showSwiper = true;
      // this.initSwip();
      // swiper.slideTo(0, 1000, true);
      // swiper.setTranslate(0, 0);
    },
    handleScroll2() {
      let note = this.$refs.note.offsetTop - 40;
      let meshine = navigator.userAgent;
      var element =
        meshine.indexOf("Weixin") == -1
          ? document.documentElement
          : document.body;
      element.scrollTop = note;
    },
    changeShow() {
      if (this.lang == "en") {
        if (this.type == "honor") {
          this.showENC = false;
          this.showENO = true;
        }
        if (this.type == "contact") {
          this.showENO = false;
          this.showENC = true;
        }
      }
    },
    changeValue(value) {
      return changeText(value);
    },
    getContactList(page, type) {
      this.$api
        .contact({
          Type:1,
          CurrentPage: page,
          ItemsPerPage:6,
        })
        .then((res) => {
          const { CompanyInfos, PagingInfo } = res.Value;
          this.contactList = CompanyInfos;
          this.PagingInfo = PagingInfo;
          if (PagingInfo.TotalPages >1) {
            this.showPage = true
          }
          if (type) {
            this.$nextTick(() => {
              new WOW({
                boxClass: "wow",
                animateClass: "animate__animated",
                live: false,
              }).init();
            });
          }
        });
    },
  },
  beforeRouteEnter(to, from,next) {
    let fromURL = from.name
    next((vm)=>{
      if(fromURL == 'newsContent')
      vm.pageCur = sessionStorage.getItem('currentPage')
    })
  },
  created() {
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        // 对路由变化做出响应...
        this.type = this.$route.params.type;
        if (this.type == "contact") {
          this.handleScroll2();
        }
        this.changeShow();
      }
    );
  },
  mounted() {
    this.type = this.$route.params.type;
    this.changeShow();
    this.showSwiper = true;
    
    this.$api
      .contact({
        Type: 1,
      })
      .then((res) => {
        const { CompanyInfos } = res.Value;
        this.contactList = CompanyInfos;

        // this.initSwip();
        new WOW({
          boxClass: "wow",
          animateClass: "animate__animated",
          live: false,
        }).init();

        if (this.type == "contact") {
          this.handleScroll2();
        }
        this.getContactList(this.pageCur, "first");
      });
  },
};
</script>

<style lang="scss">
.honorTab {
  padding: 50px 0 40px;
}
.honorList {
  display: flex;
  justify-content: space-between;
  li {
    width: 300px;
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #bfbfbf;
    flex-direction: column;
    position: relative;
    cursor: pointer;
    &::after {
      position: absolute;
      left: 50%;
      display: none;
      margin-left: -25px;
      bottom: -41px;
      content: "";
      width: 0;
      height: 0;
      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #f9f9f9;
    }
    &:hover {
      background: #c6322d;
      border: 1px solid #c6322d;
      color: #fff;
      &::after {
        display: block;
      }
    }
    .honorNum {
      font-size: 36px;
      margin-bottom: 10px;
    }
    .honorIntro {
      font-size: 26px;
      padding: 0 10px;
      text-align: center;
    }
  }
  .on {
    background: #c6322d;
    border: 1px solid #c6322d;
    color: #fff;
    &::after {
      display: block;
    }
  }
}
.honorW {
  background: #f9f9f9;
  position: relative;
  min-height: 200px;
  margin-bottom: 40px;
  &::after {
    content: ".";
    width: 100%;
    border-top: 1px solid #bfbfbf;
    position: absolute;
    left: 0;
    top: 119px;
  }
  .honorTimeB {
    overflow: hidden;
    width: 1280px;
    margin: auto;
    position: relative;
    .scollBtn,
    .scollBtnLeft {
      position: absolute;
      right: 0;
      bottom: 0;
      z-index: 9;
      cursor: pointer;
      width: 50px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
    }
    .scollBtnLeft {
      left: 0;
    }
    ul {
      display: flex;
      margin: 0;
      padding: 0;
      li {
        width: 33.333%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 60px 0;
        flex-shrink: 0;
        .time {
          font-size: 18px;
          font-weight: 400;
        }
        .point {
          display: inline-block;
          width: 15px;
          height: 15px;
          border-radius: 50%;
          background-color: #bfbfbf;
          margin: 30px 0;
        }
        &:hover {
          .name {
            color: #c6322d;
          }
        }
      }
    }
    .swiper-slide {
      height: auto;
      background: none;
    }
    .name {
      min-height: 70px;
      // max-height: auopx;
      /* overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; */
    }
  }
}
.itemJob {
  width:100%;
  .item {
  
    margin-bottom: 10px;
    font-size: 16px;
    padding: 0 50px;
  }
}
.imgMask {
  position: fixed;
  height: 100vh;
  z-index: 10;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  .imgBig {
    position: absolute;
    // margin-left: -400px;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .imgBbox {
    position: relative;
    width: 50%;
    height: 80%;
    .imgIner {
      width: 100%;
      height: 100%;
    }
    i {
      position: absolute;
      right: -15px;
      top: -15px;
      font-size: 36px;
      color: #fff;
    }
  }
}
</style>
